import type { NavigationItem } from './atoms'

export function isSamePage(a: NavigationItem, b: NavigationItem): boolean {
  return (
    a.path === b.path && a.searchParams.toString() === b.searchParams.toString()
  )
}
